module.exports = __webpack_public_path__ + "img/jaune-2.625504ee.png";